import { UserState } from './Interfaces/UserState';

const userInitialState: UserState = {
    userData: null,
    isAuth: false,
    userOrganizations: null,
};

export default userInitialState;
